import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { m as merge } from '../../unsorted/index.js';
import { getStartingSize } from '../../utils/styleHelpers.js';
import { _ as _toConsumableArray } from '../../unsorted/toConsumableArray.js';
import { getHeadingTextStyles, getBodyTextStyles, getCaptionTextStyles, isError } from '../../utils/textStyleHelpers.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { B as Box } from '../Box/Box.js';
import { useTheme } from '../../hooks/useTheme.js';

var DEFAULT_DIVIDER_SIZE = "medium";
var DIVIDER_SIZES = ["xSmall", "small", "medium", "large"];

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var baseStyles = function baseStyles(hasChildren, textAlign) {
  return _objectSpread$1({
    display: "flex",
    justifyContent: textAlign === "left" ? "flex-start" : "center",
    textAlign: textAlign,
    alignItems: "center",
    width: "100%",
    border: "none"
  }, textAlign === "left" ? {
    "&::after": {
      content: '""',
      flex: 1,
      ml: hasChildren ? "base.spacing.x6" : "0"
    }
  } : {
    "&::after, &::before": {
      content: '""',
      flex: 1
    },
    "&::after": {
      ml: hasChildren ? "base.spacing.x6" : "0"
    },
    "&::before": {
      mr: hasChildren ? "base.spacing.x6" : "0"
    }
  });
};
var getSizeBasedStyles = function getSizeBasedStyles(_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  var textStyles = size === "large" ? getHeadingTextStyles({
    size: "xSmall",
    weight: "bold",
    themeProps: theme
  }) : size === "medium" ? getBodyTextStyles({
    size: "medium",
    weight: "bold",
    themeProps: theme
  }) : getCaptionTextStyles({
    size: "small",
    weight: "bold",
    themeProps: theme
  });
  return _objectSpread$1(_objectSpread$1({}, textStyles), {}, {
    color: size === "xSmall" ? theme.base.color.text.body.secondary : theme.base.color.text.body.primary,
    "&::after, &::before": {
      height: size === "large" ? "4px" : size === "medium" ? "2px" : "1px",
      background: size === "xSmall" ? theme.base.color.translucent.emphasis[500] : theme.base.color.text.body.primary
    }
  });
};
var getResponsiveStyles = function getResponsiveStyles(_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  var sizeAsArray = Array.isArray(size) ? _toConsumableArray(size) : [size];
  sizeAsArray.shift();
  var sizeStyles = merge.apply(void 0, _toConsumableArray(sizeAsArray.map(function (responsiveSize, index) {
    if (responsiveSize != null && !isError(responsiveSize)) {
      var _theme$base$breakpoin;
      var mediaStyleRule = "@media screen and (min-width: ".concat((_theme$base$breakpoin = theme.base.breakpointAsArray) === null || _theme$base$breakpoin === void 0 ? void 0 : _theme$base$breakpoin[index], "px)");
      return _defineProperty({}, mediaStyleRule, getSizeBasedStyles({
        size: responsiveSize,
        theme: theme
      }));
    }
    return {};
  })));
  return sizeStyles;
};

var _excluded = ["size", "sx", "children", "textAlign", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Divider(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_DIVIDER_SIZE : _ref$size,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? "left" : _ref$textAlign,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var startingSize = getStartingSize(size, DEFAULT_DIVIDER_SIZE, DIVIDER_SIZES);
  var mergedSx = merge(baseStyles(children !== undefined, textAlign), getSizeBasedStyles({
    theme: theme,
    size: startingSize
  }), getResponsiveStyles({
    theme: theme,
    size: size
  }), sx);
  return jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " Divider"),
    children: children
  }));
}
Divider.displayName = "Divider";

export { Divider as D, DEFAULT_DIVIDER_SIZE as a, DIVIDER_SIZES as b };
//# sourceMappingURL=Divider.js.map
